export const environment = {
  apiUrl: 'https://procedurecard-api-dev.procedurecard.com',
  production: false,
};
